import { render } from "./InputLagGame.vue?vue&type=template&id=3b046e14&scoped=true&ts=true"
import script from "./InputLagGame.vue?vue&type=script&lang=ts"
export * from "./InputLagGame.vue?vue&type=script&lang=ts"

import "./InputLagGame.vue?vue&type=style&index=0&id=3b046e14&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b046e14"]])

export default __exports__